import { useMemo } from 'react';
import { get } from 'lodash';
import { getQuerySelectValue, useQueryContext } from '@sierralabs/query-ui';
export function getQueryValue(row, query, queryField) {
    var _a, _b;
    const select = ((_b = (_a = query.config) === null || _a === void 0 ? void 0 : _a.selects) === null || _b === void 0 ? void 0 : _b.find(select => select.selection === queryField)) || { selection: queryField };
    return getQuerySelectValue({
        item: row,
        select,
        noTransform: true,
        expressionMap: query.config
    });
}
/**
 * Get array values from query row. If the value is not an array,
 * it is wrapped to ensure that return values are arrays.
 */
export function getQueryArrayValue(row, query, queryField) {
    var _a, _b, _c, _d;
    const [alias, property] = queryField.split('.');
    let values = [];
    // check if path is main or nested oject
    if (((_b = (_a = query.config) === null || _a === void 0 ? void 0 : _a.mainAlias) === null || _b === void 0 ? void 0 : _b.name) === alias) {
        // get directly for main object
        values = [row[property]];
    }
    else {
        // for nested object, check if join exists
        const attribute = (_d = (_c = query.config) === null || _c === void 0 ? void 0 : _c.joinAttributes) === null || _d === void 0 ? void 0 : _d.find(attribute => attribute.alias.name === alias);
        const isSubQuery = !!(attribute === null || attribute === void 0 ? void 0 : attribute.alias.subQuery);
        if (attribute && !isSubQuery) {
            // get join property value
            // e.g. row: "product" entity, queryField: "userNeed.id", alias: "userNeed"
            // and so row[alias] would get "product.userNeed"
            const object = row[alias];
            const array = Array.isArray(object) ? object : [object];
            // e.g. item: "userNeed" entity, property: "id"
            values = array.map(item => item === null || item === void 0 ? void 0 : item[property]);
        }
        else {
            // otherwise, get row value similar to getQueryValue()
            values = [get(row, isSubQuery ? property : queryField)];
        }
    }
    // make sure no null and undefined values
    return values.filter(value => typeof value !== 'undefined' && value !== null);
}
export function getQueryDisplayValue(row, query, queryField) {
    var _a;
    const value = getQueryValue(row, query, queryField);
    return ((_a = value === null || value === void 0 ? void 0 : value.toString) === null || _a === void 0 ? void 0 : _a.call(value)) || null;
}
export function useQueryValue(id, field, props, asDisplay = false) {
    const { index, row: queryRow } = props || {};
    const { queries, queryResults, getRows } = useQueryContext();
    return useMemo(() => {
        const query = queries.find(query => query.id === id);
        const result = queryResults.find(result => result.queryId === id);
        const rows = result ? getRows(result) : [];
        // use query index since result?.index returns last index
        const row = queryRow || rows[index !== null && index !== void 0 ? index : -1];
        return !(row && query && field)
            ? undefined
            : asDisplay
                ? getQueryDisplayValue(row, query, field)
                : getQueryValue(row, query, field);
    }, [asDisplay, field, id, index, queries, queryResults, queryRow, getRows]);
}
export function useQueryDisplayValue(id, field, props) {
    return useQueryValue(id, field, props, true);
}
//# sourceMappingURL=useQueryDisplayValue.js.map